<template>
  <div v-if="productItem.allFlagsByCode('displayFlags').length">
    <div
      v-for="flag in productItem.allFlagsByCode('displayFlags')"
      :key="flag.code"
      class="inline-flex items-center justify-center p-4 desk:p-6 type-tagline-xs leading-single bg-bg-inverse text-text-inverse rounded-2"
    >
      {{ flag.text }}
    </div>
  </div>
  <div class="B2CNameAndCategory mb-16 desk:mb-24 mt-8">
    <div v-if="globalContent.getIsB2b" class="flex justify-between type-tagline">
      <p class="type-tagline-xs text-text-subtle mb-4">
        {{ $t('productPage.partNo.short') }} {{ activeVariant.partNo }}
      </p>
    </div>

    <div
      v-else-if="productItem.parametricByCode('ProductCollectionDynamic')?.listValue?.name"
      class="type-label-sm text-text-base"
    >
      {{ productItem.parametricByCode('ProductCollectionDynamic')?.listValue?.name }}
    </div>

    <h1 class="type-headline-xl mt-8" v-text="productItem.extendedLayout ? productItem.name : activeVariant.name" />

    <div class="mt-12">
      <ReadMore>
        <div>{{ shortDescription }}</div>
      </ReadMore>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ProductModel } from '~/models/product';
import { ProductVariantModel } from '~/models/productVariant';
import { useGlobalContentStore } from '~/store/globalContent';
import { computed } from 'vue';

const props = defineProps<{
  productItem: ProductModel,
  activeVariant: ProductVariantModel,
}>();

const globalContent = useGlobalContentStore();

const description = computed(()=> {
  const variantDescription = props.activeVariant.parametrics?.find(f => f.code === 'VariantDescription');
  if (variantDescription && variantDescription.value && variantDescription.value !== '') {
    return variantDescription.value;
  }
  return props.productItem.description;
});

const shortDescription = computed(()=> {
  const variantDescription = props.activeVariant.parametrics?.find(f => f.code === 'ShortVariantDescription');
  if (variantDescription && variantDescription.value && variantDescription.value !== '') {
    return variantDescription.value;
  }
  return props.productItem.shortDescription;
});

const chips = computed(()=> {
  return props.activeVariant.parametricByCode('B2CChips')?.multipleValues?.slice(0,3) || [];
});

</script>

<style scoped lang="postcss">
.chip-list {
  list-style: none;
  margin: 0;
  padding: 0;
}
</style>
